module.exports = __webpack_public_path__ + "img/2023-01-09d_1.f110aa98.jpg";